import { 
    Navigate, 
    Outlet 
} from "react-router-dom";
import { useAuth } from "../../lib/hooks";

export default function RequireAuth() {
    const authenticated = useAuth();

    return (
        authenticated
            ? <Outlet/>
            : <Navigate to="/auth" replace />
    )
};